import { Component } from 'react';
import { Lightning } from '@phosphor-icons/react';
import logger from '@/lib/logger';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    logger.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-6" data-testid="error-boundary">
          <div className="text-center max-w-md">
            <div className="w-16 h-16 bg-[#FF3B30]/10 border border-[#FF3B30]/30 flex items-center justify-center mx-auto mb-6">
              <Lightning weight="fill" className="w-8 h-8 text-[#FF3B30]" />
            </div>
            <h1 className="text-3xl font-black tracking-tighter mb-3 font-['Barlow_Condensed'] uppercase">Something Went Wrong</h1>
            <p className="text-[#A1A1AA] mb-6">
              An unexpected error occurred. Don't worry — your data is safe.
            </p>
            <button
              onClick={() => {
                this.setState({ hasError: false, error: null });
                window.location.href = '/dashboard';
              }}
              className="btn-primary px-6 py-3"
              data-testid="error-recovery-button"
            >
              Back to Dashboard
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
